import DossierMembershipRepositoryInterface, {
  CreateMembershipsInterface,
  MembershipInterface,
} from '@/services/Dossier/membership/interfaces';
import { AxiosInstance } from 'axios';

export default class DossierMembershipRepository implements DossierMembershipRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async createMemberships(data: CreateMembershipsInterface): Promise<MembershipInterface[]> {
    const response = await this.axios.post('/dossier-controller/memberships', data);

    return response.data;
  }

  public async removeMembership(userId: string): Promise<void> {
    await this.axios.delete(`/dossier-controller/memberships/${userId}`);
  }
}
